import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/detail/Page";

export const PATH = (id: number): string => `/deals/${id}/detail`;

const DealsDetail: NextPage = () => (
	<>
		<NskHead title="案件内容" />
		<Component />
	</>
);

export default DealsDetail;
